/**
 * Created by evgeny on 17.06.2024
 */

const Families = {}; 
Families.FurnitureByName = {};
const FamiliesIds = {};

const getFurnitureByName = function (name) {
    return Families.FurnitureByName[name];
};

Families.setFurnitureByName = function () {
    let current = 0;
    let furniture;

    if (typeof cc === "undefined") {
        const fs = require("fs");
        while (fs.existsSync(`res/locations/${current}/data.json`)) {
            furniture = require(`../../../../../wordsoup/res/locations/${current}/data.json`).items;
            furniture.forEach((furniture) => {
                Families.FurnitureByName[furniture.name] = furniture;
                Families.FurnitureByName[furniture.name].location = String(current);
            });

            current++;
        }
    } else {
        while (bundles[`location_${current}`]) {
            const data = bundles[`location_${current}`].jsons.data_json;
            if (data) {
                furniture = data.getJson().items;
                furniture.forEach((furniture) => {
                    Families.FurnitureByName[furniture.name] = furniture;
                    Families.FurnitureByName[furniture.name].location = String(current);
                });
            }

            current++;
        }
    }
};

Families.initialize = function () {
    Families.setFurnitureByName();
    Families.initializeCustomFamilies();
    Families.initializeLocationsFamilies();
    Families.afterInitialize();
};

Families.initializeCustomFamilies = function () {
    Families.multiCellBody = FamiliesHelper.MultiCellUnitFamily({}, {
        expeditions: "all"
    });

    Families.construction = FamiliesHelper.SoonFamily({
        expeditions: ["unknown"]
    });

    Families.chloepetit = FamiliesHelper.FurnitureFamily({
        furniture: getFurnitureByName("Chloe_Petit"),
        expeditions: "all"
    });

    Families.fronthallwall = FamiliesHelper.FurnitureFamily({
        furniture: getFurnitureByName("Front_Hall_Wall"),
        region: "fence_hall",
        decoratorCode: "right",
        brokenSkin: "fence_hall",
        fixedSkin: "fence_hall_0",
        invisible: true,
        expeditions: "all"
    });

    Families.sidehallwall = FamiliesHelper.FurnitureFamily({
        furniture: getFurnitureByName("Side_Hall_Wall"),
        region: "fence_hall",
        decoratorCode: "up",
        brokenSkin: "fence_hall",
        fixedSkin: "fence_hall_0",
        invisible: true,
        expeditions: "all"
    });
    Families.mainhallfloor = FamiliesHelper.FurnitureFamily({
        furniture: getFurnitureByName("Main_Hall_Floor"),
        region: "fence_hall",
        decoratorCode: "floor",
        brokenSkin: "floor_hall",
        fixedSkin: "floor_hall_0",
        invisible: true,
        expeditions: "all"
    });

    Families.cozycarpet = FamiliesHelper.FurnitureFamily({
        furniture: getFurnitureByName("Cozy_Carpet"),
        squeezable: false,
        expeditions: ["0"]
    });

    Families.leftkitchenwall = FamiliesHelper.FurnitureFamily({
        furniture: getFurnitureByName("Left_Kitchen_Wall"),
        region: "fence_kitchen",
        decoratorCode: "up",
        brokenSkin: "fence_kitchen",
        fixedSkin: "fence_kitchen_0",
        invisible: true,
        expeditions: "all"
    });

    Families.rightkitchenwall = FamiliesHelper.FurnitureFamily({
        furniture: getFurnitureByName("Right_Kitchen_Wall"),
        region: "fence_kitchen",
        decoratorCode: "right",
        brokenSkin: "fence_kitchen",
        fixedSkin: "fence_kitchen_0",
        invisible: true,
        expeditions: "all"
    });
    Families.kitchenfloor = FamiliesHelper.FurnitureFamily({
        furniture: getFurnitureByName("Kitchen_Floor"),
        region: "fence_kitchen",
        decoratorCode: "floor",
        brokenSkin: "floor_kitchen",
        fixedSkin: "floor_kitchen_0",
        invisible: true,
        expeditions: "all"
    });

    Families.rightstoragewall = FamiliesHelper.FurnitureFamily({
        furniture: getFurnitureByName("Right_Storage_Wall"),
        region: "fence_storage",
        decoratorCode: "right",
        brokenSkin: "fence_storage",
        fixedSkin: "fence_storage_0",
        invisible: true,
        expeditions: "all"
    });

    Families.leftstoragewall = FamiliesHelper.FurnitureFamily({
        furniture: getFurnitureByName("Left_Storage_Wall"),
        region: "fence_storage",
        decoratorCode: "up",
        brokenSkin: "fence_storage",
        fixedSkin: "fence_storage_0",
        invisible: true,
        expeditions: "all"
    });

    Families.storagefloor = FamiliesHelper.FurnitureFamily({
        furniture: getFurnitureByName("Storage_Floor"),
        region: "fence_storage",
        decoratorCode: "floor",
        brokenSkin: "floor_storage",
        fixedSkin: "floor_storage_0",
        invisible: true,
        expeditions: "all"
    });

    Families.leftofficewall = FamiliesHelper.FurnitureFamily({
        furniture: getFurnitureByName("Left_Office_Wall"),
        region: "fence_office",
        decoratorCode: "up",
        brokenSkin: "fence_office",
        fixedSkin: "fence_office_0",
        invisible: true,
        expeditions: "all"
    });

    Families.rightofficewall = FamiliesHelper.FurnitureFamily({
        furniture: getFurnitureByName("Right_Office_Wall"),
        region: "fence_office",
        decoratorCode: "right",
        brokenSkin: "fence_office",
        fixedSkin: "fence_office_0",
        invisible: true,
        expeditions: "all"
    });
    Families.officefloor = FamiliesHelper.FurnitureFamily({
        furniture: getFurnitureByName("Office_Floor"),
        region: "fence_office",
        decoratorCode: "floor",
        brokenSkin: "floor_office",
        fixedSkin: "floor_office_0",
        invisible: true,
        expeditions: "all"
    });

    Families.rightbathroomwall = FamiliesHelper.FurnitureFamily({
        furniture: getFurnitureByName("Wall_1"),
        region: "fence_bathroom",
        decoratorCode: "right",
        brokenSkin: "fence_bathroom",
        fixedSkin: "fence_bathroom_0",
        invisible: true,
        expeditions: "all"
    });
    Families.rightstaffroomwall = FamiliesHelper.FurnitureFamily({
        furniture: getFurnitureByName("Wall_2"),
        region: "fence_staffroom",
        decoratorCode: "right",
        brokenSkin: "fence_staffroom",
        fixedSkin: "fence_staffroom_0",
        invisible: true,
        expeditions: "all"
    });
    Families.leftstaffroomwall = FamiliesHelper.FurnitureFamily({
        furniture: getFurnitureByName("Wall_3"),
        region: "fence_staffroom",
        decoratorCode: "up",
        brokenSkin: "fence_staffroom",
        fixedSkin: "fence_staffroom_0",
        invisible: true,
        expeditions: "all"
    });
    Families.bathroomfloor = FamiliesHelper.FurnitureFamily({
        furniture: getFurnitureByName("Floor"),
        region: "fence_bathroom",
        decoratorCode: "floor",
        brokenSkin: "floor_bathroom",
        fixedSkin: "floor_bathroom_0",
        invisible: true,
        expeditions: "all"
    });
    Families.staffroomfloor = FamiliesHelper.FurnitureFamily({
        furniture: getFurnitureByName("Staff_Room_Floor"),
        region: "fence_staffroom",
        decoratorCode: "floor",
        brokenSkin: "floor_staffroom",
        fixedSkin: "floor_staffroom_0",
        invisible: true,
        expeditions: "all"
    });
    Families.leftbathroomwall = FamiliesHelper.FurnitureFamily({
        furniture: getFurnitureByName("Wall_4"),
        region: "fence_bathroom",
        decoratorCode: "up",
        brokenSkin: "fence_bathroom",
        fixedSkin: "fence_bathroom_0",
        invisible: true,
        expeditions: "all"
    });

    Families.staffroomlights = FamiliesHelper.FurnitureFamily({
        furniture: getFurnitureByName("Staff_Room_Lights"),
        completeLocation: 0,
        expeditions: ["0"]
    });
};

Families.initializeLocationsFamilies = function () {
    Object.keys(Families.FurnitureByName).forEach((name) => {
        const furniture = Families.FurnitureByName[name];
        const unitCode = furniture.code;
        if (unitCode && !Families[unitCode]) {
            Families[unitCode] = FamiliesHelper.FurnitureFamily({
                furniture,
                expeditions: [furniture.location]
            });
        }
    });
};

Families.afterInitialize = function () {
    if (cleverapps.config.debugMode && typeof exports === "undefined") {
        const unknown = cleverapps.dataLoader.load(DataLoader.TYPES.UNKNOWN_UNIT_TEST) || {};
        if (unknown.code !== undefined && unknown.stage !== undefined) {
            delete Families[unknown.code].units[unknown.stage];
        } else if (unknown.code) {
            delete Families[unknown.code];
        }
    }

    Families.codes = Object.keys(Families).filter((code) => typeof Families[code] === "object" && ["codes", "types", "FurnitureByName"].indexOf(code) === -1);

    Families.types = {};

    const allExpeditions = ["0", "1", "2", "3"];
    Families.codes.forEach((code) => {
        const family = Families[code];
        family.code = code;
        family.id = FamiliesIds[code];
        family.expeditions = family.expeditions || ["main"];
        if (!Array.isArray(family.expeditions)) {
            family.expeditions = [family.expeditions];
        }

        if (family.extraBundles && !Array.isArray(family.extraBundles)) {
            family.extraBundles = [family.extraBundles];
        }

        if (family.code === family.images) {
            console.warn(`remove ${code} images`);
            delete family.images;
        }

        if (family.type) {
            Families.types[family.type] = true;
        }
    });

    Families.codes.forEach((code) => {
        const family = Families[code];
        if (family.expeditions.indexOf("all") !== -1) {
            family.expeditions = allExpeditions;
        }
        if (family.extraBundles && family.extraBundles.indexOf("all") !== -1) {
            family.extraBundles = allExpeditions;
        }
    });

    if (typeof window === "undefined" || cleverapps.config.debugMode) {
        Families.codes.forEach((code) => {
            if (/[^a-zA-Z0-9]/.test(code)) {
                throw `Invalid family code: ${code}. The family code must match the regex [a-zA-Z0-9]`;
            }
        });
    }

    const codesById = {};
    for (const code in FamiliesIds) {
        const id = FamiliesIds[code];
        codesById[id] = code;
    }

    Families.getCompactCodeById = function (id) {
        return codesById[id];
    };

    Families.getIdByCompactCode = function (code) {
        return FamiliesIds[code];
    };

    Families.listExpeditionCodes = function (expedition) {
        const codes = Families.codes.filter((code) => Families[code].expeditions.indexOf(String(expedition)) !== -1);
        return cleverapps.createSet(codes);
    };
};

if (typeof cc === "undefined") {
    module.exports = Families;
}
